import type { ValidateRun } from '../validate/validate-runs';

/** "v3" from "3", "v3" or "V3"; null for nothing. */
export const asVersion = (v: string | null | undefined): string | null =>
  v ? `v${String(v).replace(/^v/i, '')}` : null;

/**
 * The runs that tested `version`: Validate's conversations on a Sandbox
 * channel while that version was there. Validate can only reach published
 * versions, so a draft has none.
 */
export const runsOnVersion = (
  runs: ValidateRun[],
  version: string | null
): ValidateRun[] => {
  const want = asVersion(version);
  return want
    ? runs.filter(
        (r) =>
          r.channel?.env === 'sandbox' && asVersion(r.versionLabel) === want
      )
    : [];
};
